module.exports = __webpack_public_path__ + "img/coracaoNosOlhos.40c0a73d.png";